import { TypeDictionaries } from './dictionary.popup.tsx';

/**
 * Max lengths of the grid-editable text fields per dictionary, keyed by
 * dictionaryType → grid field name. The values mirror the DB column sizes
 * (nvarchar(N), see wawi-service/db-structure) — MySQL rejects longer values
 * with "Data too long for column ..." (WA-3656), so the inputs must not let
 * the user type past the column limit.
 */
export const dictionaryFieldMaxLength: Partial<Record<TypeDictionaries, Record<string, number>>> = {
  dictArticleLists: { name: 40 }, // fkArticleLists.ArticleListName
  dictAssortmentGroups: { name: 40 }, // FakturaAssistAssortimentGroups.Name
  dictBanks: { name: 40, internalName: 40 }, // FakturaAssistBank.BankName / BankNameIntern
  dictCloudPrinters: { name: 50, serialNo: 30 }, // fkCloudPrinters.Name / SerialNo
  dictCustomerGroups: { name: 40 }, // FakturaAssistKundenGruppe.Gruppe
  dictCustomerLists: { name: 40 }, // fkCustomerLists.CustomerListName
  dictCustomerProfiles: { name: 80 }, // fkCustomerDefaultProfiles.Name
  dictDebtReminders: { name: 40 }, // FakturaAssistMahnungDefinieren.Name
  dictDeliveryNoteGroups: { name: 32 }, // FakturaAssistKonfiguration.LSGruppe1..10
  dictDiscountGroups: { name: 40 }, // FakturaAssistKonfiguration.ArtikelGruppe1..20
  dictMarketingGroups: { name: 64 }, // FakturaAssistArtikelGruppe3.Bezeichnung
  dictPostSectors: { name: 40 }, // fkPostSectors.Name
  dictPriceCategories: { name: 40 }, // FakturaAssistKonfiguration.ArtikelPreisKategorie1..10
  dictProductionGroups: { name: 64 }, // FakturaAssistArtikelGruppe.Bezeichnung
  dictQuantityDiscounts: { name: 64 }, // FakturaAssistMengenrabatt.Bezeichnung
  dictShippingPoints: { name: 64 }, // fkArticleShippingPoints.Bezeichnung
  dictStorageLocations: { name: 64 }, // fkGoodsStorageLocs.Bezeichnung
  dictSubCompanies: { companyName: 50 }, // fkSubCompanies.Name
  dictTextBlocks: { description: 64 }, // FakturaAssistTextbaustein.Bezeichnung
  dictTourplans: { name: 64 }, // FakturaAssistKundeTourenplan.Bezeichnung
};
